import { Signal } from '@angular/core';

export abstract class DeviceTagsApiService {
	// Signal to communicate an orgs tags
	public abstract allDeviceTags: Signal<string[]>;
}
